import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver/FileSaver';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FileDownloadDataServiceProvider {
	constructor(private http: HttpClient) {}

	saveFile(fileId, jobId) {
		const url = `/rest/user/jobs/${jobId}/attachments/${fileId}`;
		this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then(response => this.saveToFileSystem(response));
	}

	saveClients() {
		const url = '/protected/rest/clients/export-clients';
		this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then(response => this.saveClientsToFileSystem(response));
	}

	saveClientsTemplate() {
		const url = '/protected/rest/clients/download-csv-template';
		this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then(response => this.saveClientsTemplateToFileSystem(response));
	}

	savePayments() {
		const url = '/protected/rest/payments/export-payments';
		this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then(response => this.savePaymentsToFileSystem(response));
	}

	downloadPdf(linkToken: string, id: number, documentType?: string) {
		let url;
		switch (documentType) {
			case 'invoice':
				url = `/api/public/v1/invoice/${linkToken}/${id}/download-pdf`;
				break;
			case 'quote':
				url = `/api/public/v1/quotes/${linkToken}/${id}/download-pdf`;
				break;
			default:
				url = `/api/public/v1/quotes/${linkToken}/${id}/download-pdf`;
		}
		return this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then(response => this.savePdfToFileSystem(response));
	}

	private saveToFileSystem(response) {
		const contentDispositionHeader: string = response.headers.get(
			'Content-Disposition'
		);
		const parts: string[] = contentDispositionHeader.split(';');
		const filename = parts[1].split('=')[1];
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, filename);
	}

	private saveClientsToFileSystem(response) {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'export_clients.csv');
	}

	private savePaymentsToFileSystem(response) {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'export_payments.csv');
	}

	private saveClientsTemplateToFileSystem(response) {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'import_clients_template.csv');
	}

	private savePdfToFileSystem(response) {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, this.findFileName(response));
	}

	private findFileName(response): string {
		const value = response.headers.get('content-disposition');
		return value ? value.slice(value.indexOf('=') + 1) : 'document';
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/files/file-download-service/file-download.data.service.ts